export class ContactMask {
    /** jane@doe.com -> j***e@doe.com; anything without a local part is left as-is. */
    public static email(email: string): string {
        const value = email.trim();
        const at = value.indexOf("@");
        if (at <= 0)
            return value;

        const local = value.slice(0, at);
        const masked = local.length > 1 ? `${local[0]}***${local[local.length - 1]}` : `${local}***`;
        return `${masked}${value.slice(at)}`;
    }

    /** (305) 555-0394 -> (•••) •••-0394: hides every digit but the last four and keeps the formatting. */
    public static phone(formatted: string): string {
        const hidden = formatted.replaceAll(/\D/g, "").length - 4;
        let seen = 0;
        return formatted.replaceAll(/\d/g, digit => (seen++ < hidden ? "•" : digit));
    }
}
